import React from "react";

const renderContent = (content) => {
  if (!content) return null;
  return typeof content === "string" ? <p>{content}</p> : content;
};

const EditorialContentSection = ({
  accent,
  cards = [],
  className = "",
  closing,
  closingVariant = "light",
  eyebrow,
  feature,
  id,
  lead,
  meta = [],
  strapline,
  title,
}) => {
  const hasRail = Boolean(accent || meta.length > 0);
  const sectionClassName = [
    "section",
    "editorial-content-section",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const contentClassName = [
    "container",
    "editorial-content",
    !hasRail && "editorial-content--full",
  ]
    .filter(Boolean)
    .join(" ");
  const closingClassName = [
    "editorial-content__closing",
    closingVariant === "dark" && "editorial-content__closing--dark",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section aria-labelledby={id} className={sectionClassName}>
      <div className={contentClassName}>
        {hasRail && (
          <aside className="editorial-content__rail">
            {accent && <p className="editorial-content__accent">{accent}</p>}

            {meta.length > 0 && (
              <div className="editorial-content__meta">
                {meta.map((item) => (
                  <div className="editorial-content__meta-item" key={item.label}>
                    <span>{item.label}</span>
                    <strong>{item.value}</strong>
                  </div>
                ))}
              </div>
            )}
          </aside>
        )}

        <div className="editorial-content__main">
          {eyebrow && <p className="section-eyebrow">{eyebrow}</p>}
          <h2 id={id}>{title}</h2>

          {lead && (
            <div className="editorial-content__lead">
              {renderContent(lead)}
            </div>
          )}

          {feature && (
            <article className="editorial-content__feature">
              <span aria-hidden="true">01</span>
              <div>
                <h3>{feature.title}</h3>
                {renderContent(feature.text)}
              </div>
            </article>
          )}

          {cards.length > 0 && (
            <div className="editorial-content__cards">
              {cards.map((card, index) => (
                <article className="editorial-content__card" key={card.title}>
                  <span aria-hidden="true">
                    {String(index + 2).padStart(2, "0")}
                  </span>
                  <h3>{card.title}</h3>
                  {renderContent(card.text)}
                </article>
              ))}
            </div>
          )}

          {closing && (
            <div className={closingClassName}>
              {renderContent(closing)}
            </div>
          )}

          {strapline && (
            <p className="editorial-content__strapline">{strapline}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default EditorialContentSection;
